var map = {
	"./gainGt100.png": 90453,
	"./gainGt50Lte100.png": 52443,
	"./gainLte50.png": 84048,
	"./lossGt10Lte50.png": 77271,
	"./lossGt50.png": 27411,
	"./lossLte10.png": 99001,
	"./token/gain/DEGEN.png": 42396,
	"./token/gain/MIGGLES.png": 81488,
	"./token/gain/default.png": 54185,
	"./token/loss/DEGEN.png": 68002,
	"./token/loss/MIGGLES.png": 21204,
	"./token/loss/default.png": 41451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48207;